<template>
    <div class="data_population mt-20">
        <h4>{{ topMenuMap['Accident'].listTitle }}</h4>
        <span class="txt_r">{{ basdtVal }}</span>
        <div class="tb_st01 mt-10">
            <div class="thead">
                <table>
                    <caption>리스트헤더</caption>
                    <colgroup>
                        <col style="width: 12%;">
                        <col style="width: 22%;">
                        <col style="width: 22%;">
                        <col style="width: 44%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>발생시간</th>
                            <th>종료시간</th>
                            <th>위치</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="tbody full scroll">
                <table>
                    <caption>리스트내용</caption>
                    <colgroup>
                        <col style="width: 12%;">
                        <col style="width: 22%;">
                        <col style="width: 22%;">
                        <col style="width: 44%;">
                    </colgroup>
                    <thead style="display: none;">
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="accident in accidentList">
                            <td>{{ accidentType(accident.val2) }}</td>
                            <td>{{ getDate(accident.basdtVal) }}</td>
                            <td>{{ getDate(accident.val14) }}</td>
                            <td>{{ address(accident) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";
import { $_TYPE } from '@/confs/common.const';

export default {
    computed: {
        ...mapGetters({
            topMenuList: 'getTopMenuList',
            selectedTopMenu: 'getSelectedTopMenu',
            accidentList: 'getAccidentList',
            accidentTypeCodeMap: 'getAccidentTypeCodeMap',
        }),
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        basdtVal(){
            if(this.accidentList.length > 0) {
                let basdtVal = this.accidentList[0].basdtVal;
                return gripUtil.formatDate(basdtVal, 'yyyy-MM-dd HH:mm') + ' 기준';
            }
            return '';
        },
    },
    methods: {
        accidentType(val) {
            return this.accidentTypeCodeMap[val];
        },
        address(accident){
            return typeof accident.val6 !== $_TYPE.UNDEF && accident.val6 !== $_TYPE.NULL ? accident.val6 : accident.val4;
        },
        getDate(val) {
            return gripUtil.formatDate(val.replace(/년|월|일|시|분|\s/gi, ""), "MM-dd HH:mm", "-");
        },
    },
};
</script>
